import { useMutation } from '@tanstack/react-query'
import type { ReportQueryProps } from 'types/reports'

import { exportReportsAsCSV } from './services/exportReportsAsCSV'

export const useExportReports = () => {
  const mutation = useMutation<void, Error, ReportQueryProps>({
    mutationFn: async (query) => exportReportsAsCSV(query),
  })

  const exportReports = async (query: ReportQueryProps) => {
    return mutation.mutateAsync(query)
  }

  return {
    exportReports,
    ...mutation,
  }
}
